<template>
  <div class="page">
    <progress-system :isLoad="system.isLoad"></progress-system>
    <v-container text-xs-center fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex v-if="confirmacao != null">
          <v-avatar>
            <v-icon class="green--text text--drarken-1" size="100">mdi-email-check</v-icon>
          </v-avatar><br>
          <br>
          <br>
          <div>
            <h1 class="title">{{confirmacao}}</h1>
          </div><br><br>
          <v-btn href="/" class="blue darken-1" large dark>Efetuar login</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import ProgressSystem from '../components/ProgressSystem'
  export default{
    components:{
      ProgressSystem
    },
    data () {
      return{
        system: {
          isLoad: true
        },
        confirmacao: null,
        matricula: this.$route.params.pathMatch
      }
    },
    methods:{
      confirmarCadastro(){
        this.axios.get(`confirmandoconta/${this.matricula}`).then( res => {
          this.confirmacao = res.data
          this.system.isLoad = false
        }).catch(e => {
          this.confirmacao = e.response.data
          this.system.isLoad = false
        })
      }
    },
    mounted(){
      this.confirmarCadastro()
    }
  }
</script>
